import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const RootContainer = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;
export const TabsContainer = styled.div `
  flex-shrink: 0;
  padding: 0 ${themeGet('spacing.xl')} ${themeGet('spacing.2xl')};
`;
export const ContentContainer = styled.div `
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 ${themeGet('spacing.xl')};
`;
export const HeaderContainer = styled.div `
  display: flex;
  align-items: center;
  padding: ${themeGet('spacing.xl')};
  flex-shrink: 0;
`;
export const HeaderAction = styled.div `
  margin-left: auto;
`;
export const Footer = styled.div `
  padding: ${themeGet('spacing.xl')};
  flex-shrink: 0;
`;
